import { render } from "./RulePopup.vue?vue&type=template&id=3bb65dc3&scoped=true"
import script from "./RulePopup.vue?vue&type=script&lang=js"
export * from "./RulePopup.vue?vue&type=script&lang=js"

import "./RulePopup.vue?vue&type=style&index=0&id=3bb65dc3&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/ydsk-ph-h5-bankv3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bb65dc3"]])

export default __exports__